import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import RadioComponent from 'shared/components/RadioComponent';
import Label from 'shared/components/Label';

import { selectStencilsType } from 'shared/product_tabs/tab_stencils/slice/selectors';
import { changeStencilsType } from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';

const StencilType = ({ label, required }) => {
  const dispatch = useDispatch();
  const stencilsType = useSelector(selectStencilsType);

  const onChange = (data) => dispatch(changeStencilsType(data));

  const items = Spree.stencils_info.map((stencil) => (
    <RadioComponent
      key={stencil.id}
      name="stencil_type"
      inputId={`stencil-type-${stencil.id}`}
      label={stencil.name}
      checked={stencilsType === stencil.slug}
      onChange={() => onChange(stencil.slug)} />

  ));

  return (
    <div className="form-group">
      <Label label={label} required={required} />
      {items}
    </div>
  );
};

StencilType.defaultProps = {
  label: 'Stencil Type',
  required: false,
};

export default StencilType;
